// extracted by mini-css-extract-plugin
module.exports = {"searchFormContainer":"SearchFormWrapper_searchFormContainer__3CozM","emptyInput":"SearchFormWrapper_emptyInput__mnf8i","fullInput":"SearchFormWrapper_fullInput__12My4"};